import { DateTime } from "luxon";

export interface LocalWindow {
  localStartDate: string; // format: "DD/MM/YYYY"
  localStartTime: string; // format: "HH:mm"
  localEndDate: string;
  localEndTime: string;
}

/**
 * Converts a UTC campaign window back to its original local timezone.
 * 
 * @param utcStartDate - format: "YYYY-MM-DD"
 * @param utcStartTime - format: "HH:mm:ss"
 * @param utcEndDate - format: "YYYY-MM-DD"
 * @param utcEndTime - format: "HH:mm:ss"
 * @param selectedTimeZone - IANA time zone (e.g., "Asia/Kolkata")
 * @returns LocalWindow with dates and times in "dd/MM/yyyy" and "HH:mm" formats
 */
export function revertCampaignWindowFromUTC(
  utcStartDate: string,
  utcStartTime: string,
  utcEndDate: string,
  utcEndTime: string,
  selectedTimeZone: string
): LocalWindow {
  const utcStart = DateTime.fromISO(`${utcStartDate}T${utcStartTime}`, { zone: "utc" });
  const utcEnd = DateTime.fromISO(`${utcEndDate}T${utcEndTime}`, { zone: "utc" });

  const localStart = utcStart.setZone(selectedTimeZone);
  const localEnd = utcEnd.setZone(selectedTimeZone);

  return {
    localStartDate: localStart.toFormat("dd/MM/yyyy"),
    localStartTime: localStart.toFormat("HH:mm"),
    localEndDate: localEnd.toFormat("dd/MM/yyyy"),
    localEndTime: localEnd.toFormat("HH:mm"),
  };
}
